import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import TextareaAutosize from 'react-textarea-autosize';
import { setFormData } from '@plone/volto/actions';

interface EditableProps {
  name: string;
  value: string;
  data: Record<string, any>;
  allowLineBreaks?: boolean;
  placeholder?: string;
  block?: string;
  onChangeBlock?: (blockId: string, newData: Record<string, any>) => void;
}

const Editable = (props: EditableProps) => {
  const {
    name,
    value,
    data,
    allowLineBreaks = false,
    placeholder,
    block,
    onChangeBlock,
  } = props;
  const dispatch = useDispatch();
  const field = useRef<HTMLTextAreaElement | null>(null);

  const handleUpdate = (update: Record<string, any>) => {
    let changed = false;
    Object.keys(update).forEach((key) => {
      if (data?.[key] !== update[key]) {
        changed = true;
      }
    });
    if (!changed) {
      return;
    }
    if (block && onChangeBlock) {
      onChangeBlock(block, {
        ...data,
        ...update,
      });
      return;
    }

    dispatch(
      setFormData({
        ...data,
        ...update,
      }) as AnyAction,
    );
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !allowLineBreaks) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (field.current && field.current.value !== value) {
      field.current.value = value;
    }
  }, [value]);

  return (
    <TextareaAutosize
      ref={field}
      className="inline-edit"
      placeholder={placeholder}
      defaultValue={value}
      onKeyDown={handleKeyDown}
      onBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
        handleUpdate({
          [name]: e.target.value,
        });
      }}
    />
  );
};

export default Editable;
